var map = {
  "./desktop/index": [
    "64323",
    "76225",
    "62815",
    "38920",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "69835",
    "28009"
  ],
  "./desktop/index.tsx": [
    "64323",
    "76225",
    "62815",
    "38920",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "69835",
    "28009"
  ],
  "./mobile": [
    "97200",
    "38920",
    "17795",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "69835",
    "34427"
  ],
  "./mobile/index.tsx": [
    "97200",
    "38920",
    "17795",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "69835",
    "34427"
  ],
  "./desktop": [
    "64323",
    "76225",
    "62815",
    "38920",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "69835",
    "28009"
  ],
  "./desktop/": [
    "64323",
    "76225",
    "62815",
    "38920",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "69835",
    "28009"
  ],
  "./mobile/": [
    "97200",
    "38920",
    "17795",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "69835",
    "34427"
  ],
  "./mobile/index": [
    "97200",
    "38920",
    "17795",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "69835",
    "34427"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__(id);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 51221;
module.exports = __rspack_async_context;
